module.exports = __webpack_public_path__ + "img/group_add.d42b93db.svg";